import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import {
  ColoredHeading,
  DangerousWrapper,
  DecorativeLink,
  FootNote,
  FootNoteLink,
  Icon,
  TabContainer,
  TableofContents,
  PageHeader,
  Section,
  slugify,
  SimpleDataTable,
  Tab,
} from '@budget-monorepo/shared-ui';
import Layout from '../components/Layout';
import HelmetData from '../components/HelmetData';

const STATESPEND = (props) => {
  const { data, location } = props;
  const { download, site, content } = data;
  // eslint-disable-next-line camelcase
  const { modifiedTime, mg_mod_date, mg_mod_datetime } = content.parent;

  const layoutProps = {
    activeIndex: 3,
    pageTitle: content.title,
    dataTimeStamp: modifiedTime,
    buildTimeStamp: site.buildTime
  };

  const urlToTabIndex = (loc, tabsGroup) => {
    if (!loc.href) {
      return null;
    }
    const url = new URL(loc.href);
    const params = new URLSearchParams(url.search);
    const param = params.get(tabsGroup);
    let index = 0;
      content.tabs.every((tab, tabIndex) => {
        if (slugify(tab.title) === param) {
          index = tabIndex;
          return false;
        }
        return true;
      });
    };

  const onTabChange = (tabRef, curLocation, tabsGroup) => {
    if (global.wifndow && curLocation.href) {
      const tab = tabRef.current.innerText;
      const { href, pathname } = curLocation;
      const url = new URL(href);
      const params = new URLSearchParams(url.search);
      params.set(tabsGroup, slugify(tab));
      const newUrl = `${pathname}?${params.toString()}`;
      // eslint-disable-next-line no-undef
      window.history.replaceState({}, '', newUrl);
    }
  };

  const metaTitle = content.title;
  const metaDescription = 'COVID-19 Related Funds for Local Education Agencies.';
  return(
    <Fragment>
      <HelmetData {...{
        metaTitle,
        metaDescription,
        mg_mod_date,
        mg_mod_datetime
      }}
      />
      <Layout {...layoutProps}>
        <Section>
          {
            global.window && (
              <TabContainer defaultTab={urlToTabIndex(location, 'tab-aid')} onTabChange={(tabRef) => onTabChange(tabRef, location, 'tab-aid')}>
                {
                  content.tabs.map((tab, index) => {
                    const tabKey = `statespend-tab.${index}`;
                    return(
                      <Tab key={tabKey} title={`${tab.title} (updated ${mg_mod_date} )`}>
                        <SimpleDataTable title={`${content.title} ${tab.title}`} table={content[tab.value]} maxColWidth={150} pagination pageSize={5} download={`${location.pathname}-${tab.title}`} />
                      </Tab>
                    );
                  })
                }
              </TabContainer>
            )
          }
        </Section>
      </Layout>
    </Fragment>
  );
};

STATESPEND.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object
};

export default STATESPEND;

export const query = graphql`
  query STATESPENDJson {
    site {
      ...SiteMetadata
    }
    # Fetch the url of the excel file containing the statespend dataset for an in page download link.
    # If the file name changes, the query here (eq: "sect3.xls") will need to be updated.
    download: file(base: { eq: "sect3.xls" }) {
      publicURL
    }
    # Fetch all of the data from the statespend.json file node.
    content: pagesJson(fields: { slug: { eq: "/statespend/" } }) {
      title
      tabs {
        title
        value
      }
      statespendTable {
        filterable
        headers {
          name
          type
          align
          value
        }
        data {
          fy 
          payee 
          approp 
          area 
          account 
          dept 
          start 
          end 
          obligated 
          spent 
        }
      }

      # Get the last modified timestamp for the file powering the page
      ...PagesJsonDataTimeStamp
    }
  }
`;
